/*
 * display rounded cash prize values no matter the currency
 */
export const ESTIMATED_CASH_PRIZE_IN_USER_CURRENCY = 2000;
